import React from 'react';
import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { AvatarImagePicker } from '@/components/AvatarImagePicker';

/**
 * The user drawers' photo, a round avatar centred above the fields: clicking it picks and
 * crops a new one, as in the CRM's profile editor. The crop is kept in the form (photoBlob,
 * with imageUrl its data URL as a preview) and only uploaded when the admin saves (see
 * uploadUserPhoto).
 */
export const PhotoField = () => {
	const { values, isSubmitting, setFieldValue } = useFormikContext();
	return (
		<Grid size={12} display='flex' justifyContent='center'>
			<AvatarImagePicker
				imageUrl={values.imageUrl}
				size={120}
				isUploading={isSubmitting && Boolean(values.photoBlob)}
				onCrop={(blob, dataUrl) => {
					setFieldValue('photoBlob', blob);
					setFieldValue('imageUrl', dataUrl);
				}}
			/>
		</Grid>
	);
};
